export default __webpack_public_path__ + "static/media/network-gnosis-chain-logo.2c5a4968.svg";